import { ref, computed, type Ref } from 'vue'
import enUS from './locales/en-US'
import ptBR from './locales/pt-BR'

type Locale = 'en-US' | 'pt-BR'
type Messages = typeof enUS

const messages: Record<Locale, Messages> = {
  'en-US': enUS,
  'pt-BR': ptBR
}

const currentLocale: Ref<Locale> = ref('en-US')

function detectBrowserLocale(): Locale {
  if (typeof navigator === 'undefined') return 'en-US'

  const browserLang = navigator.language || (navigator as any).userLanguage

  if (browserLang === 'pt-BR' || browserLang === 'pt') {
    return 'pt-BR'
  }

  return 'en-US'
}

function setLocale(locale: Locale) {
  currentLocale.value = locale
  document.documentElement.lang = locale
}

function getLocale(): Locale {
  return currentLocale.value
}

function t(key: string): string {
  const keys = key.split('.')
  let result: any = messages[currentLocale.value]

  for (const k of keys) {
    if (result && typeof result === 'object' && k in result) {
      result = result[k]
    } else {
      console.warn(`Translation key not found: ${key}`)
      return key
    }
  }

  return typeof result === 'string' ? result : key
}

const locale = computed(() => currentLocale.value)

export function useI18n() {
  return {
    t,
    locale,
    setLocale,
    getLocale,
    detectBrowserLocale,
    availableLocales: ['en-US', 'pt-BR'] as const
  }
}

export function initI18n() {
  const detectedLocale = detectBrowserLocale()
  setLocale(detectedLocale)
}

export type { Locale }
